/// <reference path="../../_ext/Bases/DialogBase.ts" />
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    //@Serenity.Decorators.panel()
    //@Serenity.Decorators.maximizable()
    @Serenity.Decorators.responsive()
    export class GiftVoucherIssueDialog extends Serenity.EntityDialog<GiftVoucherIssueRow, any> {
        protected getFormKey() { return GiftVoucherIssueForm.formKey; }
        protected getIdProperty() { return GiftVoucherIssueRow.idProperty; }
        protected getLocalTextPrefix() { return GiftVoucherIssueRow.localTextPrefix; }
        protected getNameProperty() { return GiftVoucherIssueRow.nameProperty; }
        protected getService() { return GiftVoucherIssueService.baseUrl; }
        protected getDeletePermission() { return GiftVoucherIssueRow.deletePermission; }
        protected getInsertPermission() { return GiftVoucherIssueRow.insertPermission; }
        protected getUpdatePermission() { return GiftVoucherIssueRow.updatePermission; }
        //protected get_ExtDialogOptions(): ExtDialogOptions { return Q.deepClone(q.DefaultEntityDialogOptions); }
        protected useViewMode() { return true; }

        private value;
        private giftid;
        private minInvoice;
        private code;
        protected form = new GiftVoucherIssueForm(this.idPrefix);

        

        constructor() {
            super();

            q.hideEditorLabel(this.form.ItemDetails);
            q.setGridEditorHeight(this.form.ItemDetails, 400);

            this.form.GiftMasterId.changeSelect2(e => {
                this.form.Quantity.value = 0;
               // this.form.ItemDetails.emptygrid();
                var giftdetails = OMS.GiftVoucherMasterRow.getLookup().itemById[this.form.GiftMasterId.value];
                this.value = giftdetails.Value;
                this.giftid = parseInt(this.form.GiftMasterId.value);
                this.minInvoice = giftdetails.MinInvoiceValue;
                this.code = giftdetails.Code;

            });

            var fieldEditor: JQuery = this.form.Quantity.element.closest(".editor");

            //fieldEditor.addClass("ui-button");
            $(' <button type="button">Add</button>')
                .addClass('ui-button ui-corner-all ui-widget')
                .attr('height', '90%')
                .attr('margin-left', '10px')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );

        }


        protected inplaceSearchClick(e: any): void {
            if (this.form.Quantity.value > 0) {
                var quantity = parseInt(this.form.Quantity.value.toString());
                this.form.ItemDetails.setValue(quantity, this.value, this.code, this.minInvoice, this.giftid);
            }
            else {
                q.Alert('Quantity not Added', 'Please add value in quantity field', 2500, true);
            }

        }

    }
}